import React, { useState, useEffect, useContext } from "react";
import { IoEye, IoEyeOff } from "react-icons/io5";
import logo from "../images/regxlogo.png";
import { CircularProgress } from "@mui/material";
import "../Assets/css/login.css";
import "../Assets/css/common.css";
import { Link, useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { validateEmail, tokenExpire } from "../Utils";
import { getUrl } from "../Network/urls";
import { get, post } from "../Network/requests";
import headerProductUrls from "../StaticData/ProductsUrl";
// import CircularProgress from '@mui/material/CircularProgress';
import toast from "react-hot-toast";
import TextInput from "../components/UI/TextInput";
import Label from "../components/UI/Label";
// import Loader from "../components/UI/Loader";
import images from "../Resources/Images";
import regDataLogo from "../Assets/Logos/RegData_Logo.png";
import AppContext from "../Store/AppContext";
import PopUpMessage from "../components/UI/PopUpMessage";

const Login = () => {
  const [isMaintenance, setIsMaintenance] = useState(false);
  const navigate = useNavigate("");
  const {
    handleGetDecryptedData,
    handleDataEncryption,
    handleEncryptValues,
    handleEncryptOtherParamsOfAPI,
    handleDecryptResponse,
    handleAPIEncryptValue,
    clientDetails,
  } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [disabledOTPBtn, setDisabledOTPBtn] = useState(false);
  const [otp, setOtp] = useState("");
  const [sendotp, setSendOtp] = useState(false);
  const [otpErr, setOtpErr] = useState("");
  const [passwordErr, setPasswordErr] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);
  const [timer, setTimer] = useState(300); // 300 seconds = 5 minutes // uncomment
  const [resendTimer, setResendTimer] = useState(30);
  const [isEnabledReSentOTP, setIsEnabledResentOTP] = useState(false);
  const [showTimer, setShowTimer] = useState(false);
  const [isTimerOver, setIsTimerOver] = useState(false); // uncomment
  const [buttonText, setButtonText] = useState(""); // uncomment
  const [isButtonClicked, setIsButtonClicked] = useState(false); // uncomment
  const [email, setEmail] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [password, setPassword] = useState("");
  const [countDownId, setCountDownId] = useState(null);
  const [resendTextTimerId, setResendTextTimerId] = useState(null);
  const [emailErr, setEmailErr] = useState("");
  const [enabledSendOTPBtn, setEnabledSendOTPBtn] = useState(true);
  const [isOTPInputBoxEnabled, setIsOTPInputBoxEnabled] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [OTPLoader, setOTPLoader] = useState(false);
  const integerReg = /^\d+$/;

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await fetch(
          "https://regdatauat.reg-x.co.uk/config.json"
        );
        const data = await response.json();
        setIsMaintenance(data.isMaintenance);
      } catch (error) {
        console.error("Failed to fetch config:", error);
      }
    };

    fetchConfig();
    localStorage.removeItem("regulationName");
  }, []);

  const handleDataDecryption = (encryptedData, encryptionKey, iv) => {
    try {
      const encryptedDataBytes = CryptoJS.enc.Base64.parse(encryptedData);
      const ivBytes = CryptoJS.enc.Base64.parse(iv);
      const decryptedBytes = CryptoJS.AES.decrypt(
        { ciphertext: encryptedDataBytes },
        CryptoJS.enc.Utf8.parse(encryptionKey),
        { iv: ivBytes, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
      );
      const decryptedData = decryptedBytes.toString(CryptoJS.enc.Utf8);
      const parsedData = JSON.parse(decryptedData);
      return parsedData;
    } catch (error) {
      return null;
    }
  };

  const isFormValidate = () => {
    if (handleEmail() && handlePassword()) return true;
    else return false;
  };

  const handleClearIntervals = () => {
    if (countDownId || resendTextTimerId) {
      clearInterval(countDownId);
      clearInterval(resendTextTimerId);
    }
  };

  const handleLocalStorageData = (body) => {
    // console.log('body :', body);
    const IdToken = localStorage.getItem("userToken");
    localStorage.setItem("userToken", IdToken);
    handleDataEncryption(
      "RegDataVal1",
      body?.REACT_APP_ACCESS_KEY_ID.toString(),
      IdToken.slice(27, 47)
    );
    handleDataEncryption(
      "RegDataVal2",
      body?.REACT_APP_SECRET_ACCESS_KEY.toString(),
      IdToken.slice(27, 47)
    );
    handleDataEncryption(
      "RegDataVal3",
      body?.REACT_APP_INPUT_BUCKET.toString(),
      IdToken.slice(27, 47)
    );
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (otp.length === 6) {
      handleClearIntervals(); // clear a previously set interval.
      setLoading(true);
      const url = getUrl("user-login");
      const firmSpecUrl = getUrl("get-firm-spec");
      const apiPayload = {
        httpMethod: "POST",
        parameters: {
          email: email,
          password: password,
          operation: "challenge",
          otp: otp,
          session_token: localStorage.getItem("sessionToken"),
        },
      };

      const loginData = JSON.stringify(apiPayload);
      post(`${url}`, loginData, false)
        .then((response) => {
          const {
            data: { body, authData },
          } = response;
          // console.log(response, '--response.data.statusCode');
          switch (response.data.statusCode) {
            case 200: {
              const secretKey = `${authData.IdToken.slice(998, 1030)}`;
              const iv = authData.iv_b64;
              const decryptedData = handleDataDecryption(
                body.toString(),
                secretKey.toString(),
                iv.toString()
              );
              // console.log(decryptedData, '--decryptedData');
              localStorage.setItem("userToken", authData?.IdToken);
              handleLocalStorageData(decryptedData); // Storing data to local storage
              const { clientId } = decryptedData;
              const paramsObj = { clientId };
              const encryptedParamsObj =
                handleEncryptOtherParamsOfAPI(paramsObj);
              const data = {
                client_id: encryptedParamsObj?.clientId,
                email_id: decryptedData?.email,
              };
              const regdataData = handleAPIEncryptValue(JSON.stringify(data));

              get(`${firmSpecUrl}?regdata=${regdataData}`, true)
                .then((res) => {
                  let redirectUrl = "";
                  // console.log(res, '---res');
                  const iv1 = res.data.authData;
                  const body1 = handleDecryptResponse(
                    res.data.encryptBody.toString(),
                    secretKey.toString(),
                    iv1.toString()
                  );
                  // console.log(body1, '--body1');
                  let emptyList = [];
                  let dict = {};
                  let sortedProductsData = body1.data.sort();
                  let productCode = "";
                  let regulationCode = "";
                  let subscribedProcucts = {};
                  // console.log("8");
                  // console.log(sortedProductsData, '---login spd');
                  switch (res.status) {
                    case 200:
                      for (let i = 0; i < sortedProductsData.length; i++) {
                        let element = sortedProductsData[i];
                        // console.log(element, '--element');
                        if (element[1] === "P001") {
                          //--------------------------
                          redirectUrl = headerProductUrls[`${element[1]}`];
                        }
                        if (element[1] in dict) {
                          emptyList.push(element[2]);
                          dict[`${element[1]}`] = emptyList;
                        } else {
                          emptyList = [];
                          emptyList.push(element[2]);
                          dict[`${element[1]}`] = emptyList;
                        }
                      }
                      for (let i = 0; i < sortedProductsData.length; i++) {
                        //-----------
                        let elementNew = sortedProductsData[i];
                        if (redirectUrl === "") {
                          redirectUrl = headerProductUrls[`${elementNew[1]}`];
                          break;
                        }
                      }
                      // console.log("9");
                      // console.log('dict', dict);
                      // console.log('res body', decryptedData);
                      decryptedData.dataAccess = dict;
                      // console.log('body dataaccesss', decryptedData);
                      toast.success("Logged in Successfully!");
                      // localStorage.setItem(
                      //   'clientDetails',
                      //   JSON.stringify(body),
                      // );
                      handleDataEncryption(
                        "RegDataVal4",
                        JSON.stringify(decryptedData),
                        authData?.IdToken.slice(27, 47)
                      ); // Storing cliet details data to local storage
                      // console.log(decryptedData, '--decryptedData');
                      handleEncryptValues(decryptedData);
                      subscribedProcucts = decryptedData.dataAccess;
                      productCode = Object.keys(subscribedProcucts);
                      // regulationCode = subscribedProcucts[`${productCode}`][0];
                      regulationCode = Object.values(
                        decryptedData.dataAccess
                      )[0]?.[0];
                      handleDataEncryption(
                        "RegDataVal5",
                        JSON.stringify(productCode),
                        authData?.IdToken.slice(27, 47)
                      );
                      //  localStorage.setItem('productCode', productCode);
                      handleDataEncryption(
                        "RegDataVal6",
                        regulationCode,
                        authData?.IdToken.slice(27, 47)
                      );
                      handleGetDecryptedData();
                      setLoading(false);
                      navigate(`${redirectUrl}`);
                      break;
                    default:
                      setLoading(false);
                      toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
                      break;
                  }
                })
                .catch((error) => {
                  setLoading(false);
                  toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
                  tokenExpire(error.response, navigate);
                  // console.log("10");
                });
              localStorage.removeItem("sessionToken");
              break;
            }
            case 400:
              setEnabledSendOTPBtn(true);
              setIsEnabledResentOTP(true);
              toast.error(body.message);
              setLoading(false);
              break;
            default:
              setLoading(false);
              toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
              break;
          }
        })
        .catch((error) => {
          toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
          tokenExpire(error.response, navigate);
          setLoading(false);
        });
    } else {
      toast.error("Enter 6 digit OTP.");
    }
  };

  const handleEmail = () => {
    if (email.trim() === "") {
      setEmailErr("Email address is required.");
      setEmail("");
    } else if (!validateEmail(email)) {
      setEmailErr("Please enter a valid email address.");
    } else {
      setEmailErr("");
      return true;
    }
    return false;
  };

  const handleOTP = () => {
    if (otp.trim() === "") {
      setOtpErr("OTP is required.");
      return false;
    } else {
      setOtpErr("");
      return true;
    }
  };

  const handlePassword = () => {
    if (password === "") {
      setPasswordErr("Password is required");
      return false;
    } else {
      setPasswordErr("");
      return true;
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      switch (e.target.name) {
        case "input-email":
          if (handleEmail()) {
          }
          break;
        case "otp":
          if (handleOTP()) {
            handleFormSubmit(e);
          }
          break;
        case "input-password":
          if (handlePassword()) {
            handleSendOTP(e);
          }
          break;
        default:
          break;
      }
    }
  };

  const handleTimer = () => {
    setTimer(300);
    const countdown = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer > 0) {
          return prevTimer - 1;
        }
        setShowTimer(false);
        setIsOTPInputBoxEnabled(false);
        setIsTimerOver(true);
        return 0;
      });
    }, 1000);
    setCountDownId(countdown);
  };

  const handleResendTimer = () => {
    setResendTimer(30);
    const countdown = setInterval(() => {
      setResendTimer((prevTimer) => {
        if (prevTimer > 0) {
          return prevTimer - 1;
        }
        setIsEnabledResentOTP(true);
        setEnabledSendOTPBtn(true);
        clearInterval(countdown);
        return 0;
      });
    }, 1000);
    setResendTextTimerId(countdown);
  };

  const handleSendOTP = (e) => {
    e.preventDefault();
    if (isFormValidate()) {
      setOTPLoader(true);
      setIsTimerOver(false);
      const url = getUrl("user-login");
      const operation = "initiate_auth";
      const apiPayload = {
        httpMethod: "POST",
        parameters: {
          email: email,
          password: password,
          operation: operation,
          otp: "",
        },
      };
      const loginData = JSON.stringify(apiPayload);
      post(`${url}`, loginData, false).then((response) => {
        const {
          data: { body },
        } = response;
        const statusCode = body?.statusCode;
        switch (statusCode) {
          case 200:
            setOtp("");
            localStorage.setItem("sessionToken", body.session_token);
            toast.success(body.message);
            handleClearIntervals();
            setShowTimer(true);
            handleTimer();
            handleResendTimer();
            setEnabledSendOTPBtn(false);
            setIsEnabledResentOTP(false);
            setIsOTPInputBoxEnabled(true);
            setOTPLoader(false);
            break;
          case 400:
            setOTPLoader(false);
            toast.error(body.message);
            break;
          default:
            setOTPLoader(false);
            toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
            break;
        }
      });
    }
  };

  const handleCheckOTP = (e) => {
    if (!otp?.trim()) {
      toast.error("Please Enter OTP...");
    } else if (otp.length < 6) {
      toast.error("Please Enter 6 Digit OTP...");
    } else {
      handleFormSubmit(e);
    }
  };

  return (
    <>
      {/* {loading && <Loader />} */}
      <div className="rx_login_wrapper" style={{ flexDirection: "row" }}>
        <div
          className="position-relative d-flex"
          style={{ width: "59%", height: "100vh" }}
        >
          <div className="left_login_section">
            <div className="d-flex align-items-end">
              <img
                src={regDataLogo}
                style={{ width: "auto", height: "50px" }}
                alt="RegData logo"
              />
              {/* <h2 className="left_login_sectoin_uat">UAT</h2> */}
            </div>
            <div>
              <p
                style={{
                  color: "rgba(255, 255, 255, 0.89)",
                  lineHeight: "24px",
                }}
              >
                RegData, developed by Reg-X, is a record-keeping platform
                designed to ensure regulatory compliance. It stores past data in
                the required format while maintaining data quality. The platform
                presents information in a structured table format for easy
                access and client utility.
              </p>
            </div>
            <PopUpMessage width="55rem" />
          </div>
        </div>
        <div className="rx_login_inner">
          {isMaintenance ? (
            <div style={{ textAlign: "center", paddingTop: "20px" }}>
              <img
                src={images.MaintenanceImage}
                alt="Maintenance Mode"
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </div>
          ) : (
            <>
              <div className="login_header">
                <div className="login_logo">
                  <img
                    src={logo}
                    alt="logo"
                    style={{ width: "100%", height: "100%" }}
                  />
                </div>
                <h5>Login</h5>
              </div>
              <div className="rx_login_form">
                <div className="rx_form_block">
                  <Label label="Email" classNameStyle="rx_form_label" />
                  <TextInput
                    type="text"
                    placeholder="Enter your email"
                    name="input-email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    onKeyPress={handleKeyPress}
                    classNameStyle="rx_form_field"
                  />
                  {emailErr !== "" ? (
                    <div className="invalid-feedback d-block">{emailErr}</div>
                  ) : null}
                </div>
                <div className="rx_form_block">
                  <Label label="Password" classNameStyle="rx_form_label" />
                  <div className="position-relative">
                    <TextInput
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      name="input-password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      onBlur={() => {}}
                      onFocus={() => {}}
                      onKeyPress={handleKeyPress}
                      classNameStyle="login-password"
                      // onKeyPress={handleKeyPress}
                    />
                    {showPassword ? (
                      <IoEye
                        size={20}
                        className="password-icons"
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    ) : (
                      <IoEyeOff
                        size={20}
                        className="password-icons"
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    )}
                  </div>
                  {passwordErr !== "" ? (
                    <div className="invalid-feedback d-block">
                      {passwordErr}
                    </div>
                  ) : null}
                </div>
                <div className="rx_login_btn">
                  <button
                    className="login_btn"
                    type="button"
                    name="sendotp"
                    disabled={!enabledSendOTPBtn}
                    onClick={handleSendOTP}
                    // onKeyPress={handleEmailKeyPress}
                  >
                    {OTPLoader ? (
                      <CircularProgress sx={{ color: "white" }} size={26} />
                    ) : isEnabledReSentOTP ? (
                      "Resend OTP"
                    ) : (
                      "Send OTP"
                    )}
                  </button>
                  <div
                    className="d-flex justify-content-between"
                    style={{ marginTop: "5px" }}
                  >
                    <div>
                      {showTimer && (
                        <p className="fw-bold m-0" style={{ color: "#2c2c2c" }}>
                          {Math.floor(timer / 60)}:
                          {timer % 60 < 10 ? `0${timer % 60}` : timer % 60}
                        </p>
                      )}
                      {isTimerOver && (
                        <p className="fw-bold" style={{ color: "red" }}>
                          Timer Over
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="rx_form_block" style={{ marginTop: "10px" }}>
                  <Label label="OTP" classNameStyle="rx_form_label" />
                  <input
                    type="text"
                    placeholder="Enter 6 digit  OTP"
                    name="otp"
                    value={otp}
                    disabled={!isOTPInputBoxEnabled}
                    maxLength={6}
                    onChange={(e) =>
                      e.target.value !== ""
                        ? integerReg.test(e.target.value.trim()) &&
                          setOtp(e.target.value)
                        : setOtp("")
                    }
                    className="rx_form_field"
                    style={{ color: "black" }}
                    onKeyPress={handleKeyPress}
                  />
                </div>
                {otpErr !== "" ? (
                  <div className="invalid-feedback d-block">{otpErr}</div>
                ) : null}
                <div className="rx_login_btn">
                  <button
                    className="login_btn"
                    // disabled={otp.length !== 6}
                    onClick={handleCheckOTP}
                  >
                    {loading ? (
                      <CircularProgress sx={{ color: "white" }} size={26} />
                    ) : (
                      "Log In"
                    )}
                  </button>
                </div>
                <div className="bottom-buttons">
                  <Link to="/registration-page">Register User</Link>
                  <Link to="/forgot-password">Forgot Password</Link>
                </div>
              </div>
            </>
          )}
        </div>
        <h6 style={{ position: 'fixed', bottom: '10px', left: '59%', right: 0, textAlign: 'center', margin: 0, fontSize: '13px' }}>
            © {new Date().getFullYear()} Reg-X Innovations Ltd. All rights reserved.
          </h6>
      </div>
    </>
  );
};

export default Login;
